import React from 'react'
import PropTypes from 'prop-types'

const ActionHubFabIcon = ({ width, height, color }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="28" fill="#151D34" />
    <mask
      id="mask0_5766_4233"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="16"
      y="16"
      width="24"
      height="24"
    >
      <rect x="16" y="16" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5766_4233)">
      <path
        d="M30.5998 24.075C30.5998 23.3583 30.3623 22.7833 29.8873 22.35C29.4123 21.9167 28.7831 21.7 27.9998 21.7C27.5165 21.7 27.079 21.8042 26.6873 22.0125C26.2956 22.2208 25.9581 22.525 25.6748 22.925C25.4081 23.3083 25.0456 23.5292 24.5873 23.5875C24.129 23.6458 23.7331 23.525 23.3998 23.225C23.1665 23.0083 23.0373 22.7417 23.0123 22.425C22.9873 22.1083 23.0665 21.8083 23.2498 21.525C23.7831 20.725 24.4623 20.1042 25.2873 19.6625C26.1123 19.2208 27.0165 19 27.9998 19C29.6165 19 30.929 19.4583 31.9373 20.375C32.9456 21.2917 33.4498 22.4917 33.4498 23.975C33.4498 24.725 33.2915 25.4 32.9748 26C32.6581 26.6 32.0748 27.3083 31.2248 28.125C30.6081 28.7083 30.1915 29.1625 29.9748 29.4875C29.7581 29.8125 29.6165 30.1833 29.5498 30.6C29.4831 31 29.3123 31.3333 29.0373 31.6C28.7623 31.8667 28.4331 32 28.0498 32C27.6665 32 27.3373 31.8708 27.0623 31.6125C26.7873 31.3542 26.6498 31.0333 26.6498 30.65C26.6498 30 26.7915 29.4042 27.0748 28.8625C27.3581 28.3208 27.8331 27.75 28.4998 27.15C29.3498 26.4 29.9123 25.8208 30.1873 25.4125C30.4623 25.0042 30.5998 24.5583 30.5998 24.075ZM27.9998 38C27.4498 38 26.979 37.8042 26.5873 37.4125C26.1956 37.0208 25.9998 36.55 25.9998 36C25.9998 35.45 26.1956 34.9792 26.5873 34.5875C26.979 34.1958 27.4498 34 27.9998 34C28.5498 34 29.0206 34.1958 29.4123 34.5875C29.804 34.9792 29.9998 35.45 29.9998 36C29.9998 36.55 29.804 37.0208 29.4123 37.4125C29.0206 37.8042 28.5498 38 27.9998 38Z"
        fill={color}
      />
    </g>
  </svg>
)

ActionHubFabIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
}

ActionHubFabIcon.defaultProps = {
  width: 32,
  height: 32,
  color: 'white',
}

export default ActionHubFabIcon
